import styles from "./journalmobilecard.module.css";
import { AlertTriangle, Edit, Image, MoreVertical, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const JournalMobileCard = ({ item, setDeleteId, setDeleteModalOpen, setJournalDetails, setOpenEditForm, setLoading }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();

    const getJouranalDetails = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios(process.env.REACT_APP_TENANT_API_URL + "v1/journals/" + item?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setOpenEditForm(true);
            setJournalDetails(response.data.data);
        }).catch(() => {
            setLoading(false);
        });
    }

    return (<Link to={"/security/journal/details/" + item?.id} className={`${styles.MaintenanceReqCard}`}>
        {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 || user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1) && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); }}>
            <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                <MoreVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { getJouranalDetails(); }}>
                    <Edit /> Edit
                </Dropdown.Item>}
                {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteId(item?.id); setDeleteModalOpen(true); }}>
                    <Trash2 /> Delete
                </Dropdown.Item>}
            </Dropdown.Menu>
        </Dropdown>}
        <div className={`${styles.CardImgSec} Secondary`}>
            <p>{item?.user_initial}</p>
        </div>
        <div className={`${styles.MainReCardCon}`}>
            <div>
                <p className={`${styles.Title}`}>
                    {dayjs(item?.date).format("MM/DD/YYYY")}
                    {item?.is_unusual === 1 && <AlertTriangle />}
                    {item?.no_of_images > 0 && <span><Image /></span>}
                </p>
                <div className={`${styles.MainReCardIdStatus}`}>
                    <div className={`${styles.MainReID}`} dangerouslySetInnerHTML={{ __html: item.description }}></div>
                </div>
            </div>
        </div>
    </Link>);
};

export default JournalMobileCard;